import script from "./FaqsViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqsViewPage.vue?vue&type=script&setup=true&lang=js"

import "./FaqsViewPage.vue?vue&type=style&index=0&id=c7d0c31a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7d0c31a"]])

export default __exports__